import React, { useEffect, useState } from "react";
import { Close, LogoBlack } from "../../../assets/svg";
import CustomTable from "../../../components/customTable/CustomTable";
import {
  DefaultButton,
  DefaultPrimaryButton,
} from "../../../components/micro/input";
import {
  createDocument,
  getAllReportList,
  getServiceReportById,
  getServiceReportList,
  sendAllReportList,
} from "../../../redux/service/slice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import RippleLoader from "../../../components/loader/RippleLoader";
import SendMailModal from "./SendMailModal";
import { toast } from "react-toastify";
import { getBillingSettingList } from "../../../redux/masterSetting/slice";
import { ProgressBar } from "react-bootstrap";
import ButtonLoader from "../../../components/loader/ButtonLoader";

const ViewServiceReport = ({
  onClose,
  selectedSaleId,
  setIsLoading,
  isLoading,
  showSend,
  iscompany,
  setSelectedAction,
  setServiceCount,
  setSelectedRows,
  schedule,
}) => {
  const dispatch = useDispatch();
  const [serviceData, setServiceData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [progress, setProgress] = useState(0);

  const { loading, billingSettingData } = useSelector((store) => ({
    loading: store?.serviceData?.loading,
    billingSettingData:
      store?.settingData?.getBillingSettingListStatus?.data?.data,
  }));

  const handleCloseModal = () => {
    setIsModal(false);
  };

  useEffect(() => {
    const fetchSalesData = async () => {
      let serviceReports = [];
      setProgress(0);

      if (showSend === "bulk") {
        const response = await dispatch(
          getAllReportList({ ids: selectedSaleId })
        );

        const totalItems = response?.payload?.data?.length || 0;

        for (let i = 0; i < totalItems; i++) {
          serviceReports.push(response?.payload?.data[i]);

          const percent = Math.round(((i + 1) / totalItems) * 100);
          setProgress(percent);

          await new Promise((resolve) => setTimeout(resolve, 100));
        }
        if (serviceReports?.length > 0) {
          const documentIds = serviceReports
            .map((report) => report.documents?.id)
            .filter((id) => id !== undefined);

          setDocumentData(documentIds);
        }
        setServiceData(serviceReports);
      } else {
        const results = await Promise.all(
          selectedSaleId.map((id) => dispatch(getServiceReportById({ id })))
        );
        serviceReports = results.map((res) => res.payload?.data);
        setServiceData(serviceReports);
      }
    };

    if (selectedSaleId?.length > 0) {
      fetchSalesData();
    }

    dispatch(getBillingSettingList());
  }, [selectedSaleId]);

  const handleDownloadPDF = async () => {
    if (showSend === "bulk") {
      const response = await dispatch(
        createDocument({ ids: documentData })
      ).unwrap();

      const zipUrl = response?.zip;
      if (zipUrl) {
        const a = document.createElement("a");
        a.href = zipUrl;
        a.download = "report_documents.zip";
        document.body.appendChild(a);
        a.click();
        a.remove();
        onClose();
        dispatch(
          getServiceReportList({
            search: "",
            pageCount: 1,
            pageLimit: 10,
            sort_by: "",
            sort_direction: "",
            technician: "",
            status: "",
          })
        );
        setSelectedAction("");
        setServiceCount("");
        setSelectedRows([]);
      } else {
        toast.error("ZIP URL not found in response.");
      }
    } else {
      try {
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();

        for (let i = 0; i < serviceData.length; i++) {
          const pageContent = document.getElementById(`salePage-${i}`);

          const canvas = await html2canvas(pageContent, { scale: 2 });
          const imgData = canvas.toDataURL("image/png");
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

          if (i > 0) {
            pdf.addPage();
          }
          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

          if (i === serviceData.length - 1) {
            pdf.save("service_preview.pdf");
            toast.success("Your file has been downloaded successfully!");
          }
        }
      } catch (error) {
        toast.error("PDF Download Error:", error);
      }
    }
  };

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-1/6"
      >
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-5/6 "
      >
        Problem
      </th>
    </>
  );

  const DataRows = ({ data }) => (
    <>
      {data?.service_report_equipments?.map((element, index) => (
        <tr
          key={element.id}
          className="font-Proxima text-[14px] shadow-sm text-mgrey"
        >
          <td className="px-5 py-3">{index + 1}</td>
          <td className="px-5 py-3">{element?.problem_description}</td>
        </tr>
      ))}
    </>
  );

  const SolutionColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-1/6"
      >
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start w-5/6"
      >
        Solution
      </th>
    </>
  );

  const SolutionDataRows = ({ data }) => (
    <>
      {data?.service_report_equipments?.map((element, index) => (
        <tr className="font-Proxima text-[14px] shadow-sm  text-mgrey ">
          <td className="px-5 py-3">{index + 1}</td>
          <td className="px-5 py-3">{element?.solution_description}</td>
        </tr>
      ))}
    </>
  );

  const handleSendReport = () => {
    setIsLoading(true);

    const payload = {
      ids: selectedSaleId,
    };

    dispatch(sendAllReportList(payload)).then((res) => {
      setIsLoading(false);

      if (res.type === "sendAllReportList/fulfilled") {
        onClose();
        dispatch(
          getServiceReportList({
            search: "",
            pageCount: 1,
            pageLimit: 10,
            sort_by: "",
            sort_direction: "",
            technician: "",
            status: "",
          })
        );
        setSelectedAction("");
        setServiceCount("");
        setSelectedRows([]);
      }
    });
  };

  return (
    <>
      <div className="model" onClick={onClose}>
        <div
          className="bg-white rounded-lg max-w-5xl py-8 px-6 mx-auto relative max-h-[90vh] overflow-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {showSend === "bulk" ? (
            <div className="flex gap-2">
              <p className="text-sm font-normal font-Proxima text-mgrey">
                Preview ({selectedSaleId?.length})
              </p>
              <div>
                <ProgressBar
                  now={progress}
                  label={`${progress}% Loaded`}
                  className="text-black text-sm font-normal font-Proxima flex"
                />
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="cursor-pointer flex justify-end">
            <button onClick={onClose}>
              <Close />
            </button>
          </div>
          <div>
            {loading ? (
              <div className="max-w-72">
                <RippleLoader />
              </div>
            ) : (
              <>
                {serviceData?.map((data, index) => {
                  const billing = billingSettingData?.data?.[0] || {};
                  const uniqueId = data?.unique_id || "00000";
                  const reportNumber = uniqueId.startsWith("FBK-")
                    ? uniqueId.replace("FBK-", "")
                    : uniqueId;
                  const typeOfService = data?.type_of_service || "";
                  const isContract = typeOfService
                    ?.toLowerCase()
                    .includes("contract");
                  const isWarranty = typeOfService
                    ?.toLowerCase()
                    .includes("warranty");
                  const isChargeable = typeOfService
                    ?.toLowerCase()
                    .includes("chargeable");

                  return (
                    <div
                      key={index}
                      id={`salePage-${index}`}
                      className="mx-auto bg-white"
                      style={{
                        width: "210mm",
                        padding: "28px 32px",
                        fontFamily: "Arial, sans-serif",
                        color: "#000",
                      }}
                    >
                      {/* Header Section - Logo left, Company info immediately to the right */}
                      <div className="flex items-start mb-3">
                        <div className="mr-6 flex-shrink-0">
                          <LogoBlack />
                        </div>
                        <div style={{ lineHeight: "1.4" }}>
                          <p className="text-[14px] font-Proxima text-gray-600 mb-1">
                            UEN: 201402444D
                          </p>
                          <p className="text-2xl font-Montserrat font-semibold text-primaryBlack mb-1 border-b-2 border-themeBtn max-w-72">
                            FBK GROUP PTE LTD
                          </p>
                          <p className="text-xl font-Montserrat font-semibold text-primaryBlack">
                            fnbkitchen.com.sg
                          </p>
                          <div className="max-w-full overflow-hidden text-nowrap">
                            <p className="text-sm font-Proxima text-primaryBlack border-b-2 border-themeBtn">
                              3 Ubi Ave 3 #03-04 Crocodile House S408857{" "}
                              <span className="text-themeBtn font-bold text-2xl">
                                •
                              </span>{" "}
                              <span className="font-bold">E:</span>{" "}
                              info@fbk.com.sg{" "}
                              <span className="text-themeBtn mx-1 text-2xl">
                                •
                              </span>{" "}
                              <span className="font-bold">T:</span> 64433824{" "}
                              <span className="text-themeBtn mx-1 text-2xl">
                                •
                              </span>{" "}
                              <span className=" font-bold">F:</span> 64433825
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Service Report Title with Report Number */}
                      <div className="flex justify-between items-center mb-6">
                        <h1 className="text-4xl font-Montserrat font-bold text-primaryBlack">
                          Service Report
                        </h1>
                        <p className="text-base font-Proxima text-primaryBlack">
                          No.: <span>FBK-</span>
                          <span className="text-themeBtn">{reportNumber}</span>
                        </p>
                      </div>

                      {/* Type of Service Section */}
                      <div className="mb-6 border border-black p-3">
                        <p className="text-sm font-Proxima font-bold text-primaryBlack mb-2">
                          Type Of Service:
                        </p>
                        <div className="flex gap-6">
                          <label className="flex items-center text-sm font-Proxima text-primaryBlack">
                            <input
                              type="checkbox"
                              checked={isContract}
                              readOnly
                              className="mr-2 w-4 h-4"
                              style={{ accentColor: "#000" }}
                            />
                            Contract 合約
                          </label>
                          <label className="flex items-center text-sm font-Proxima text-primaryBlack">
                            <input
                              type="checkbox"
                              checked={isWarranty}
                              readOnly
                              className="mr-2 w-4 h-4"
                              style={{ accentColor: "#000" }}
                            />
                            Warranty 保修期
                          </label>
                          <label className="flex items-center text-sm font-Proxima text-primaryBlack">
                            <input
                              type="checkbox"
                              checked={isChargeable}
                              readOnly
                              className="mr-2 w-4 h-4"
                              style={{ accentColor: "#000" }}
                            />
                            Chargeable 收费(S):
                          </label>
                        </div>
                      </div>

                      {/* Customer Information Section */}
                      <div className="mb-6 space-y-2">
                        <div className="flex items-center border-b border-black pb-1">
                          <span className="text-sm font-Proxima font-bold text-primaryBlack w-32">
                            Customer 公司
                          </span>
                          <span className="text-sm font-Proxima text-primaryBlack">
                            {data?.company?.name || "-"}
                          </span>
                        </div>
                        <div className="flex items-center border-b border-black pb-1">
                          <span className="text-sm font-Proxima font-bold text-primaryBlack w-32">
                            Address 地址
                          </span>
                          <span className="text-sm font-Proxima text-primaryBlack">
                            {data?.company?.address || "-"}{" "}
                            {data?.company?.postal_code || ""}
                          </span>
                        </div>
                        <div className="flex items-center border-b border-black pb-1">
                          <span className="text-sm font-Proxima font-bold text-primaryBlack w-32">
                            Contact Person 联系人
                          </span>
                          <span className="text-sm font-Proxima text-primaryBlack">
                            {data?.service?.customers?.full_name || "-"}
                          </span>
                        </div>
                        <div className="flex items-center border-b border-black pb-1">
                          <span className="text-sm font-Proxima font-bold text-primaryBlack w-32">
                            Contact No 联系方式
                          </span>
                          <span className="text-sm font-Proxima text-primaryBlack">
                            {data?.company?.phone || "-"}
                          </span>
                        </div>
                        <div className="flex items-center border-b border-black pb-1">
                          <span className="text-sm font-Proxima font-bold text-primaryBlack w-32">
                            Serial No 编号
                          </span>
                          <span className="text-sm font-Proxima text-primaryBlack">
                            {data?.serial_number || "-"}
                          </span>
                        </div>
                      </div>

                      {/* Description and Quantity Table */}
                      <div className="mb-6">
                        <table
                          className="w-full border-collapse"
                          style={{ border: "1px solid #000" }}
                        >
                          <thead>
                            <tr
                              style={{
                                backgroundColor: "rgba(183, 44, 34, 0.04)",
                              }}
                            >
                              <th className="px-3 py-2 text-left font-Proxima text-sm font-normal text-primaryBlack border border-black">
                                S/N
                              </th>
                              <th className="px-3 py-2 text-left font-Proxima text-sm font-normal text-primaryBlack border border-black">
                                Description 描述
                              </th>
                              <th className="px-3 py-2 text-left font-Proxima text-sm font-normal text-primaryBlack border border-black">
                                Quantity 数量
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.serviceItemDetails?.items &&
                            data.serviceItemDetails.items.length > 0
                              ? data.serviceItemDetails.items.map(
                                  (equipment, eqIndex) => (
                                    <tr
                                      key={equipment?.id || eqIndex}
                                      className="font-Proxima text-sm text-primaryBlack"
                                    >
                                      <td className="px-3 py-2 border border-black">
                                        {eqIndex + 1}.
                                      </td>
                                      <td className="px-3 py-2 border border-black">
                                        {equipment?.product_name || "-"}
                                      </td>
                                      <td className="px-3 py-2 border border-black">
                                        {equipment?.quantity || "-"}
                                      </td>
                                    </tr>
                                  )
                                )
                              : Array.from({ length: 6 }).map((_, rowIndex) => (
                                  <tr
                                    key={rowIndex}
                                    className="font-Proxima text-sm text-primaryBlack"
                                  >
                                    <td className="px-3 py-2 border border-black">
                                      {rowIndex + 1}.
                                    </td>
                                    <td className="px-3 py-2 border border-black"></td>
                                    <td className="px-3 py-2 border border-black"></td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Problem Section */}
                      <div
                        className="mb-6 border border-black p-3"
                        style={{ minHeight: "120px" }}
                      >
                        <p className="text-sm font-Proxima font-bold text-primaryBlack mb-2">
                          Problem 问题
                        </p>
                        <div className="text-sm font-Proxima text-primaryBlack whitespace-pre-wrap">
                          {data?.service_report_equipments &&
                          data.service_report_equipments.length > 0
                            ? data.service_report_equipments
                                .map((eq, idx) => {
                                  let problemText = eq?.problem_description;
                                  if (!problemText) return null;
                                  // Ensure it's a string
                                  if (typeof problemText !== "string") {
                                    problemText = String(problemText);
                                  }
                                  return (
                                    <div key={idx} className="mb-1">
                                      {idx + 1}. {problemText}
                                    </div>
                                  );
                                })
                                .filter(Boolean)
                            : null}
                        </div>
                      </div>

                      {/* Solution Section */}
                      <div
                        className="mb-6 border border-black p-3"
                        style={{ minHeight: "120px" }}
                      >
                        <p className="text-sm font-Proxima font-bold text-primaryBlack mb-2">
                          Solution 解决方法
                        </p>
                        <div className="text-sm font-Proxima text-primaryBlack whitespace-pre-wrap">
                          {data?.service_report_equipments &&
                          data.service_report_equipments.length > 0
                            ? data.service_report_equipments
                                .map((eq, idx) => {
                                  let solutionText = eq?.solution_description;
                                  if (!solutionText) return null;
                                  // Ensure it's a string
                                  if (typeof solutionText !== "string") {
                                    solutionText = String(solutionText);
                                  }
                                  return (
                                    <div key={idx} className="mb-1">
                                      {idx + 1}. {solutionText}
                                    </div>
                                  );
                                })
                                .filter(Boolean)
                            : null}
                        </div>
                      </div>

                      {/* Date and Time Tracking Table */}
                      <div className="mb-6">
                        <table
                          className="w-full border-collapse"
                          style={{ border: "1px solid #000" }}
                        >
                          <thead>
                            <tr
                              style={{
                                backgroundColor: "rgba(183, 44, 34, 0.04)",
                              }}
                            >
                              <th className="px-3 py-2 text-left font-Proxima text-sm font-normal text-primaryBlack border border-black">
                                Date Started 开始日期
                              </th>
                              <th className="px-3 py-2 text-left font-Proxima text-sm font-normal text-primaryBlack border border-black">
                                Date Done 结束日期
                              </th>
                              <th className="px-3 py-2 text-left font-Proxima text-sm font-normal text-primaryBlack border border-black">
                                Time Started 开始时间
                              </th>
                              <th className="px-3 py-2 text-left font-Proxima text-sm font-normal text-primaryBlack border border-black">
                                Time Done 结束时间
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="font-Proxima text-sm text-primaryBlack">
                              <td className="px-3 py-2 border border-black">
                                {data?.date || data?.service?.date
                                  ? moment(
                                      data.date || data.service.date
                                    ).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td className="px-3 py-2 border border-black">
                                {data?.date_done || data?.service?.date_done
                                  ? moment(
                                      data.date_done || data.service.date_done
                                    ).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td className="px-3 py-2 border border-black">
                                {data?.start_time ||
                                  data?.service?.start_time ||
                                  "-"}
                              </td>
                              <td className="px-3 py-2 border border-black">
                                {data?.end_time ||
                                  data?.service?.end_time ||
                                  "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Signature Section */}
                      <div className="flex justify-between items-start mt-8">
                        <div>
                          <div className="h-16 w-48 mb-2"></div>
                          {data?.technician_signature && (
                            <img
                              src={data.technician_signature}
                              alt="Technician Signature"
                              className="w-48 h-16 object-contain"
                            />
                          )}
                          <p className="text-sm font-Proxima text-primaryBlack border-b-2 border-black">
                            {data?.technician_name || ""}
                          </p>
                          <p className="text-sm font-Proxima font-bold text-primaryBlack ">
                            Technician's Signature
                          </p>
                        </div>
                        <div>
                          <div className="h-16 w-48 mb-2"></div>
                          {data?.status === "acknowledged" &&
                            data?.customer_signature && (
                              <img
                                src={data.customer_signature}
                                alt="Customer Signature"
                                className="w-48 h-16 object-contain"
                              />
                            )}
                          <p className="text-sm font-Proxima text-primaryBlack border-b-2 border-black">
                            {data?.outlet_name || data?.company?.name || ""}
                          </p>
                          <p className="text-sm font-Proxima font-bold text-primaryBlack ">
                            Customer's Signature
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {/* submit */}
                {schedule ? (
                  " "
                ) : (
                  <div className="flex justify-end gap-2 mt-3">
                    <DefaultPrimaryButton
                      value="download"
                      onClick={handleDownloadPDF}
                    />
                    {iscompany !== "iscompany" && (
                      <DefaultButton
                        value={isLoading ? <ButtonLoader /> : "Send Email"}
                        onClick={() => {
                          showSend === "bulk"
                            ? handleSendReport()
                            : setIsModal(true);
                        }}
                      />
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {isModal && (
        <SendMailModal
          onClose={handleCloseModal}
          selectedSaleId={selectedSaleId}
          serviceData={serviceData}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default ViewServiceReport;
